module.exports = __webpack_public_path__ + "media/fonts/MatterSQ-Regular-c95320ddb6acdfeaf390f0ff8bcebb2b.ttf";